import React from 'react';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

/*
  workaround for styled components
  https://github.com/mui-org/material-ui/issues/11467
 */
const Tooltip: React.FunctionComponent<TooltipProps> = ({ className, children, ...props }) => (
  <MuiTooltip classes={{ popper: className }} {...props}>
    {children}
  </MuiTooltip>
);

export default Tooltip;
